export default "__VITE_ASSET__d0104293__"